export enum ActionTypesDocumentReferences {
  SET_LOADING_INDICATOR = 'SET_LOADING_INDICATOR',
  SET_DOCUMENT_REFERENCES_DATA = 'SET_DOCUMENT_REFERENCES_DATA',
  SHOW_DOCUMENT_REFERENCES_GRID = 'SHOW_DOCUMENT_REFERENCES_GRID',
  RESET_DOCUMENT_REFERENCES_DATA = 'RESET_DOCUMENT_REFERENCES_DATA',
  SET_DISABLED_COLUMNS = 'SET_DISABLED_COLUMNS',
}
export const DOCUMENT_REFERENCES_GRID_RECORD_MESSAGE = 'No records to display at this time.';
export const DOCUMENT_REFERENCES_GRID_TITLE = 'Document References';
export const DOCUMENT_REFERENCES_GRID_COLUMNS = new Set([
  {
    dataName: 'documentReferenceKey',
    text: 'Document Reference Key',
    sortable: true,
    isSorted: 0,
    width: '150px',
  },
  {
    dataName: 'source',
    text: 'Source',
    sortable: true,
    isSorted: 0,
    width: '150px',
  },
  {
    dataName: 'label',
    text: 'Label',
    sortable: true,
    isSorted: 0,
    width: '150px',
  },
  {
    dataName: 'urlHyperlink',
    text: 'URL',
    sortable: true,
    isSorted: 0,
    width: '150px',
    cellType: 'custom',
  },
  {
    dataName: 'modifiedBy',
    text: 'Modified By',
    sortable: true,
    isSorted: 0,
    width: '150px',
  },
  {
    dataName: 'lastModified',
    text: 'Last Modified',
    sortable: true,
    isSorted: 0,
    width: '150px',
  },
  {
    dataName: 'statusChip',
    text: 'Status',
    sortable: true,
    cellType: 'chip',
    isSorted: 0,
    headerWidth: 80,
    isHeaderTruncated: true,
  },
]);

export const DOCUMENT_REFERENCES_DEFAULT_COLUMNS = new Set([
  'documentReferenceKey',
  'source',
  'label',
  'urlHyperlink',
  'statusChip',
  'modifiedBy',
  'lastModified',
]);

export const STATUS_DROPDOWN = [
  { label: 'Inactive', value: 'Inactive' },
  { label: 'Active', value: 'Active' },
];
